// Gift card logs (legacy GiftCardLogsComponent): GET gift_cards/logs/{id}.
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { ArrowLeft2 } from 'iconsax-reactjs';

import { fetchRecord } from '../../api/client';
import { moneyValue } from '../../crud/configHelpers';
import { formatDateTime, t, tLabel } from '../../i18n';
import { RemoteTable, type RemoteColumn } from './RemoteTable';

type Log = Record<string, unknown>;

export function GiftCardLogsPage() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const [card, setCard] = useState<Record<string, unknown> | null>(null);

  useEffect(() => {
    fetchRecord<Record<string, unknown>>('gift_cards', id).then(setCard).catch(() => setCard(null));
  }, [id]);

  const columns: RemoteColumn<Log>[] = [
    { key: 'created_at', label: tLabel('Created At'), sortable: true, render: (row) => formatDateTime(row.created_at) },
    { key: 'amount', label: tLabel('Amount'), sortable: true, align: 'right', render: (row) => moneyValue(row.amount) },
    { key: 'description', label: tLabel('Description'), sortable: true }
  ];

  return (
    <Stack spacing={2}>
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={2}>
          <Box>
            <Typography variant="h4" fontWeight={700}>{t('catalog.giftCardLogs.title')}</Typography>
            {card ? (
              <Typography variant="body2" color="text.secondary">
                {t('catalog.giftCardLogs.subtitle', { number: String(card.number ?? ''), balance: moneyValue(card.balance), amount: moneyValue(card.amount) })}
              </Typography>
            ) : null}
          </Box>
          <Button startIcon={<ArrowLeft2 size={16} />} onClick={() => navigate('/gift-cards')}>{t('catalog.giftCardLogs.back')}</Button>
        </Stack>
      </Paper>
      <RemoteTable<Log> endpoint={`gift_cards/logs/${id}`} columns={columns} />
    </Stack>
  );
}
